import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AsmService } from '../service/asm.service';
import { GrowlService } from '../service/growl.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private growlService: GrowlService,
                private asmService: AsmService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError((err: any) => {
                    if (err instanceof HttpErrorResponse && err.status >= 500) {
                        err.headers.get('X-Support-Id') && !this.isAsmStoreRoute(req)
                            ? this.asmService.logAsmPayload(req, err.headers.get('X-Support-Id'))
                            : this.growlService.showErrorGrowl('ERROR.500');
                    }
                    return throwError(err);
                })
            );
    }

    private isAsmStoreRoute(request) {
        return (request.url || '').toLowerCase().includes('/api/public/asm') && (request.method || '').toLowerCase() === 'post';
    }
}
